import authSessionManager from "../auth/sessionManager";

export const handleResponseError = (error) => {
    let errorMessages = [];

    if (error.response) {
        // if error 403 fhen redirect to login page
        if (error.response.status === 401) {
            if (window.location.pathname !== "/login") {
                const currentUrl = `${window.location.pathname}${window.location.search}`;
                authSessionManager.handleUnauthorized(currentUrl);
            }
        }

        errorMessages = [...error.response?.data?.errors, ...errorMessages];
    } else if (error.request) {
        errorMessages.push({
            message: 'Network error'
        });
    } else {
        errorMessages.push({
            message: error.message || 'Failed to setup request'
        });
    }
    return errorMessages;
};